// extracted by mini-css-extract-plugin
export default {"overlay":"CustomModal_overlay__7UMQE","wrapper":"CustomModal_wrapper__Tb-vD","modal":"CustomModal_modal__u-qqK"};